// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { CategoriesContext } from 'Contexts/CategoriesContext';

export default function useCategories() {
  return useContext(CategoriesContext);
}
